import 'rxjs/add/operator/switchMap';
import {OnInit, Component} from '@angular/core';
import {Contest} from './core/contest';
import {DeathService} from './death.service';

@Component({
    moduleId: module.id,
    selector: 'current-contest-summary',
    templateUrl: './current-contest-summary.component.html'
})

export class CurrentContestSummaryComponent implements OnInit{

    contest: Contest;

    constructor(private deathService: DeathService) {}

    ngOnInit(): void {
        this.getContests();
    }

    getContests(): void {
        this.deathService
            .getCurrentContest()
            .subscribe(contest => this.contest = contest);
    }

    hasAnyQualifyingDeaths(): boolean {
        let score = 0;
        this.contest.deathRecords.forEach((deathRecord) =>
            score += deathRecord.score
        )

        return score > 0;
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/current-contest-summary.component.ts